import {Action} from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ContactModel } from '@smarttask-common/src/lib/models/Record/Contact/Core/ContactModel';

export enum ContactActionTypes {
  ADD_CONTACT = '[Contact] Create Contact',
  UPSERT_CONTACT = '[Contact] Upsert Contact',
  ADD_CONTACTS = '[Contact] Add Contacts',
  UPSERT_CONTACTS = '[Contact] Upsert Contacts',
  UPDATE_CONTACT = '[Contact] Update Contact',
  UPDATE_CONTACTS = '[Contact] Update Contacts',
  DELETE_CONTACT = '[Contact] Delete Contact',
  DELETE_CONTACTS = '[Contact] Delete Contacts',
  DELETE_STATE = '[Contact] Delete State',

  UPDATE_SELECTED_ID = '[Contact] Update SelectedId'
}

export class UpdateSelectedContactId implements Action{
  readonly type = ContactActionTypes.UPDATE_SELECTED_ID;
  constructor(public selected_record_id: string){}
}

export class AddOne implements Action{
  readonly type = ContactActionTypes.ADD_CONTACT;
  constructor(public contact: ContactModel){

  }
}

export class AddMany implements Action{
  readonly type = ContactActionTypes.ADD_CONTACTS;
  constructor(public contacts: Array<ContactModel>){

  }
}

export class UpsertOne implements Action {
  readonly type = ContactActionTypes.UPSERT_CONTACT;

  constructor(
    public contact: ContactModel) {}
}

export class UpsertMany implements Action {
  readonly type = ContactActionTypes.UPSERT_CONTACTS;
  constructor(public contacts: Array<ContactModel> ) {}
}

export class UpdateOne implements Action{
  readonly type = ContactActionTypes.UPDATE_CONTACT;
  constructor(
    public id: string, 
    public changes: Partial<ContactModel>
  ){
    
  }
}
export class UpdateMany implements Action{
  readonly type = ContactActionTypes.UPDATE_CONTACTS;
  constructor(
    public updates: Array<Update<ContactModel>>
  ){
    
  }
}

export class DeleteOne implements Action{
  readonly type = ContactActionTypes.DELETE_CONTACT;
  constructor(
    public id: string
  ){}
}

export class DeleteMany implements Action{
  readonly type = ContactActionTypes.DELETE_CONTACTS;
  constructor(
    public ids: Array<string>
  ){}
}

export class DeleteState implements Action{
  readonly type = ContactActionTypes.DELETE_STATE;
  constructor(){}
}

export type ContactActions = 
  AddOne 
  | AddMany 
  | UpsertOne 
  | UpsertMany 
  | DeleteOne 
  | DeleteMany 
  | DeleteState
  | UpdateOne
  | UpdateMany
  | UpdateSelectedContactId;